export const LANGUAGE_VERSIONS = {
  javascript: "18.15.0",
  typescript: "5.0.3",
  python: "3.10.0",
  java: "15.0.2",
  php: "8.2.3",
};

export const TENANT = "neetie";
// export const TENANT = "testschool";
export const LANGUAGES = ["javascript", "typescript", "python", "java", "php"];
